// src/context/FavoriteContext.jsx
import React, { createContext, useContext } from 'react';
import { useQuery } from "@tanstack/react-query";
import { getFavorites } from "../services/apiFavorites";
import { useParams } from "react-router-dom";

const FavoriteContext = createContext(null);

export const FavoriteProvider = ({ children }) => {
    const { slug } = useParams();

    const {
        data: favorites,
        isLoading,
        error,
        refetch
    } = useQuery({
        // Keep under ["favorites"] so useSendFavorites invalidation / cache sync applies
        queryKey: ["favorites", "count", slug],
        queryFn: () => getFavorites("product"),
        enabled: !!slug,
        staleTime: 0,
        gcTime: 5 * 60 * 1000,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
        retry: 1,
    });

    const value = {
        favorites,
        isLoading,
        error,
        refetch,
        favoritesCount: favorites?.data?.total_favorites_count || 0 // ✅ قيمة جاهزة
    };

    return (
        <FavoriteContext.Provider value={value}>
            {children}
        </FavoriteContext.Provider>
    );
};

// Hook للوصول للـ context
export const useFavorites = () => {
    const context = useContext(FavoriteContext);

    if (!context) {
        throw new Error('useFavorites must be used within FavoriteProvider');
    }

    return context;
};
